import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import UpdateResolvedAutoReplyMutation from '../../../../../mutations/ticketing/admin/useUpdateResolvedAutoReplyMutation';

export interface UpdateResolvedAutoReplyInput {
	resolvedEnabled: boolean;
	resolvedFromName: string;
	resolvedFromEmail: string;
	resolvedBodyHtml: string;
}

// ACC-551: mirrors useUpdateAutoReply for the resolved-trigger auto-reply.
export function useUpdateResolvedAutoReply() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function update(input: UpdateResolvedAutoReplyInput): Promise<void> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				UpdateResolvedAutoReplyMutation,
				input,
				() => {
					setLoading(false);
					resolve();
				},
				err => {
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {update, loading, error, setError};
}
